// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__28_AS","footer":"ModalFilter_footer__11NUU"};